/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Configurator: React.FC<Props> = ({ color = '#000000', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <path
        d="M9.5 14C11.1569 14 12.5 15.3431 12.5 17C12.5 18.6568 11.1569 20 9.5 20C7.84315 20 6.5 18.6568 6.5 17C6.5 15.3431 7.84315 14 9.5 14Z"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
      />
      <path
        d="M14.5 4C12.8431 4 11.5 5.34314 11.5 7C11.5 8.65685 12.8431 10 14.5 10C16.1569 10 17.5 8.65685 17.5 7C17.5 5.34314 16.1569 4 14.5 4Z"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
      />
      <path
        d="M15 16.9585H22"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 6.9585H2"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2 16.9585H4"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M22 6.9585H20"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default Configurator;
